module.exports = __webpack_public_path__ + "img/logobw.2f9caf46.png";